import { useState } from 'react';

const useProcessingProgress = () => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const updateProgress = (value, statusText) => {
    setProgress(value);
    setStatus(statusText);
  };

  const startProgress = () => {
    setIsLoading(true);
    setIsComplete(false);
    setProgress(0);
    setStatus('');
  };

  const completeProgress = () => {
    setProgress(100);
    setIsComplete(true);
    setIsLoading(false);
  };

  const resetProgress = () => {
    setProgress(0);
    setStatus('');
    setIsComplete(false);
    setIsLoading(false);
  };

  const simulateProgress = async (stages) => {
    startProgress();

    for (const stage of stages) {
      updateProgress(stage.progress, stage.status);
      await new Promise(resolve => setTimeout(resolve, stage.duration || 500));
    }

    await new Promise(resolve => setTimeout(resolve, 500));
    completeProgress();
  };

  return {
    progress,
    status,
    isComplete,
    isLoading,
    updateProgress,
    startProgress,
    completeProgress,
    resetProgress,
    simulateProgress
  };
};

export default useProcessingProgress;
